import type { FunctionComponent } from 'react';

interface IProps {
    years: number[];
}

export const TimeLineBar: FunctionComponent<IProps> = ({ years }) => {
    return (
        <>
            <div className="timeline-bar">
                {years.map((year) => (
                    <div key={year}>
                        <span className="timeline-year">
                            <span className="timeline-year__title">{year}</span>
                            <span className="timeline-year__dot" />
                        </span>
                    </div>
                ))}
            </div>
        </>
    );
};
